<div
  class="talc-color-selector-container like-mat-form-field"
  [ngClass]="{'disabled-field': disabled}"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxFlex="100"
>
  <div class="label">
    <span>رنگ طلق</span>
    <span *ngIf="selected"> : ({{ selected.name }}) </span>
  </div>
  <div
    class="colors"
    fxLayout="row"
    fxLayoutAlign="space-evenly center"
    *ngIf="talcColors && talcColors.length > 0 && !disabled"
  >
    <app-talc-color
      *ngFor="let color of talcColors; index as i"
      [colorCode]="color.colorCode"
      [name]="color.name"
      [selected]="selected && selected.colorCode === color.colorCode"
      [class.selected]="selected && selected.colorCode === color.colorCode"
      (click)="selectColor(i)"
      class="color"
    ></app-talc-color>
  </div>
</div>
